import React, { useContext } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { ThemeContext } from './ThemeContext.js'

const Footer = () => {
  const { theme } = useContext(ThemeContext)

  return (
    <footer>
      <Container>
        <br />
        <Row>
          <Col className='text-center' style={{ color: theme.subtext }}>
            Copyright &copy; Hermanos Gazpachos Inc. 2026. All rights reserved.
          </Col>
        </Row>
      </Container>
    </footer>
  )
}

export default Footer
